import React from 'react';
import { Progress } from '../ui/progress';
import { Sparkles } from 'lucide-react';

export const FundingProgress = ({ biz, formatCurrency, large = false }) => {
  const investors = biz.investors || 0;
  const raised = biz.raised || 0;
  if (!investors) {
    return (
      <p className="flex items-center gap-1 text-sm text-[#00E676]" data-testid={`first-investor-${biz.business_id}`}>
        <Sparkles className="w-4 h-4" /> Be the first investor
      </p>
    );
  }
  const pct = biz.goal ? (raised / biz.goal) * 100 : 0;
  return (
    <div data-testid={`funding-${biz.business_id}`}>
      <div className="flex justify-between text-sm mb-2">
        <span className="text-gray-400">Raised · {investors} investor{investors === 1 ? '' : 's'}</span>
        <span className="text-white">{formatCurrency(raised)} / {formatCurrency(biz.goal)}</span>
      </div>
      <Progress value={pct} className={`${large ? 'h-3' : 'h-2'} bg-white/10`} />
      {large && <p className="text-xs text-gray-500 mt-1">{pct.toFixed(1)}% funded</p>}
    </div>
  );
};
